import type { context_engine } from "@dropbox/api-v2-client/types/dropbox_types";
import type { DocumentInfo } from "@mirage/service-conversation/types";

export function convertDocumentInfoToApiV2ContextEngineDocumentInfo(
  documentInfo: DocumentInfo,
): context_engine.DocumentInfo {
  const result: context_engine.DocumentInfo = {
    url: documentInfo.url || "",
    title: documentInfo.title || "",
    last_updated_ms: documentInfo.lastUpdatedMs || 0,
    branded_type: documentInfo.brandedType || "",
    body: documentInfo.body || "",
    owner_id: documentInfo.ownerId || "",
    third_party_id: documentInfo.thirdPartyId || "",
    relevance_score: documentInfo.relevanceScore || 0,
    uuid: documentInfo.uuid || "",
    index: documentInfo.index || "",
    transient: documentInfo.transient || false,
    citation_type: documentInfo.citationType || "",
    retrieval_source: documentInfo.retrievalSource || "",
    preview_url: documentInfo.previewUrl || "",
    inclusion_type: documentInfo.inclusionType || "",
  };

  if (documentInfo.connectorInfo) {
    result.connector_info = {
      connector_id: documentInfo.connectorInfo.connectorId || "",
      connector_type: documentInfo.connectorInfo.connectorType || 0,
      display_name: documentInfo.connectorInfo.displayName || "",
      platform: documentInfo.connectorInfo.platform || 0,
      connector_name: documentInfo.connectorInfo.connectorName || "",
      connector_icon_url: documentInfo.connectorInfo.connectorIconUrl || "",
    };

    if (documentInfo.connectorInfo.icon) {
      result.connector_info.icon = {
        light_url: documentInfo.connectorInfo.icon.lightUrl || "",
        dark_url: documentInfo.connectorInfo.icon.darkUrl || "",
        light_png_url: documentInfo.connectorInfo.icon.lightPngUrl || "",
        dark_png_url: documentInfo.connectorInfo.icon.darkPngUrl || "",
      };
    }
  }

  if (documentInfo.fileTypeInfo) {
    result.file_type_info = {
      id: documentInfo.fileTypeInfo.id || "",
      display_name: documentInfo.fileTypeInfo.displayName || "",
    };

    if (documentInfo.fileTypeInfo.icon) {
      result.file_type_info.icon = {
        light_url: documentInfo.fileTypeInfo.icon.lightUrl || "",
        dark_url: documentInfo.fileTypeInfo.icon.darkUrl || "",
        light_png_url: documentInfo.fileTypeInfo.icon.lightPngUrl || "",
        dark_png_url: documentInfo.fileTypeInfo.icon.darkPngUrl || "",
      };
    }
  }

  if (documentInfo.channel) {
    result.channel = {
      id: documentInfo.channel.id || "",
      name: documentInfo.channel.name || "",
      url: documentInfo.channel.url || "",
      created_at_ms: documentInfo.channel.created_at_ms || 0,
      type: documentInfo.channel.type || { ".tag": "channel_type_unset" },
    };
  }

  if (documentInfo.fssRetrieverInfo) {
    result.fss_retriever_info = {
      fss_file_identifier: {
        file_id: documentInfo.fssRetrieverInfo.fssFileIdentifier.fileId || "",
      },
    };
  }

  return result;
}
